import { Box, Typography, Paper } from "@mui/material";

function Home() {
  return (
    <Box
      sx={{
        bgcolor: "#ffffffff",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 6,
          borderRadius: "16px",
          textAlign: "center",
          maxWidth: 500,
          width: "100%",
          bgcolor: "#ffffff",
        }}
      >
        <Typography
          variant="h4"
          fontWeight={700}
          gutterBottom
          sx={{ color: "#222" }}
        >
          Welcome to Dashboard
        </Typography>
      </Paper>
    </Box>
  );
}

export default Home;
